import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d190fa4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "control-plane" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, null, -1))
const _hoisted_5 = { class: "input-list" }
const _hoisted_6 = { class: "sections" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CourseEditorButton = _resolveComponent("CourseEditorButton")!
  const _component_input_field_text = _resolveComponent("input-field-text")!
  const _component_input_field_text_area = _resolveComponent("input-field-text-area")!
  const _component_CourseEditorItemSection = _resolveComponent("CourseEditorItemSection")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_CourseEditorButton, {
          onCreateCourse: _ctx.saveCourse,
          text: "Сохранить"
        }, null, 8, ["onCreateCourse"])
      ]),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_input_field_text, {
          name: "Название",
          prompt: "Введите название курса",
          notes: "Макс. 70 символов",
          maxlength: "70",
          modelValue: _ctx.title,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.title) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_input_field_text_area, {
          name: "Краткое описание курса",
          prompt: "Небольшое описание курса",
          notes: "Макс. 200 символов",
          maxlength: "200",
          modelValue: _ctx.course_data.brief_summary,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.course_data.brief_summary) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.course_data.sections, (section, index) => {
          return (_openBlock(), _createBlock(_component_CourseEditorItemSection, {
            key: section.id,
            id: section.id,
            order: index,
            onAddSection: ($event: any) => (_ctx.addSection(index + 1))
          }, null, 8, ["id", "order", "onAddSection"]))
        }), 128))
      ])
    ])
  ]))
}